import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store.js'

Vue.use(Router)

const router = new Router({
	routes: [
		{
			path: '/',
			name: 'default',
			meta: { requiresLogin: true }
		},
		{
			path: '/home',
			name: 'home',
			meta: { requiresLogin: true },
			component: () => import( /* webpackChunkName: "home" */ './views/view-home.vue'),
		},
		{
			path: '/synthesis',
			name: 'synthesis',
			meta: { requiresLogin: true },
			component: () => import( /* webpackChunkName: "synthesis" */ './views/view-synthesis.vue')
		},
		{
			path: '/search',
			name: 'search',
			meta: { requiresLogin: true },
			component: () => import( /* webpackChunkName: "search" */ './views/view-search.vue')
		},
		{
			path: '/login',
			name: 'login',
			component: () => import( /* webpackChunkName: "home" */ './views/view-login.vue')
		},
		{
			path: '*',
			redirect: '/login'
		},
	]
});

router.beforeEach(async (to, from, next) => {

	// go to login without redirect from logout -> clean logout message
	if(from.name==null && to.name =="login" ){
		store.dispatch('set_message_logout',"")
	}

	//check login for all routes excepted login route
	 if(to.name !="login"){
		await store.dispatch('checktoken')
	 }
	
	//console.log('is_authenticated : ',store.getters.is_authenticated)

	if (to.matched.some(record => record.meta.requiresLogin) && store.getters.is_authenticated === false) {
		store.dispatch('set_redirect_route', { redirect_route: to.fullPath })
		next({
			name: "login", // back to safety route //
			// query: { redirectFrom: to.fullPath }
		  });
	} else {
		if(to.name=='default'){
			next(	{name: "home"})
		}else{
			next()
		}
	}
		
});

export default router;